export default __webpack_public_path__ + "static/media/icon-support-1.7f149d36.svg";